import React, { cloneElement } from "react";
import { useSettings } from "../hooks";
import { PageWidth } from "../components";
import { ReactComponent as Yelp } from "./yelp.svg";
import { ReactComponent as Facebook } from "./facebook.svg";
import { ReactComponent as Twitter } from "./twitter.svg";

export function TopBar() {
  const {
    phoneNumber,
    emailAddress,
    yelpUrl,
    facebookUrl,
    twitterUrl,
  } = useSettings();

  return (
    <div className="pv4 bg-near-white gray">
      <PageWidth className="overflow-hidden">
        <div className="flex-l items-center-l nl4-l nr4-l tc tl-l">
          <div className="ph4-l">
            <PhoneNumber {...{ phoneNumber }} />
          </div>
          <div className="ph4-l">
            <EmailAddress {...{ emailAddress }} />
          </div>
          <div className="ml-auto-l ph4-l flex items-center justify-center mt3 mt0-l">
            <Icon id="top-bar-yelp-url" href={yelpUrl} first>
              <Yelp />
            </Icon>
            <Icon id="top-bar-facebook-url" href={facebookUrl}>
              <Facebook />
            </Icon>
            <Icon id="top-bar-twitter-url" href={twitterUrl}>
              <Twitter />
            </Icon>
          </div>
        </div>
      </PageWidth>
    </div>
  );
}

function PhoneNumber({ phoneNumber = "" }) {
  return (
    <div>
      <a
        className="no-underline color-inherit"
        href={`tel:+1${phoneNumber.replace(/\D+/g, "")}`}
        id="top-bar-phone-number"
      >
        {phoneNumber}
      </a>
    </div>
  );
}

function EmailAddress({ emailAddress = "" }) {
  return (
    <div>
      <a
        className="no-underline color-inherit"
        href={`mailto:${emailAddress}`}
        id="top-bar-email-address"
      >
        {emailAddress}
      </a>
    </div>
  );
}

function Icon({ href, children, id, first }) {
  const updatedChildren = children
    ? cloneElement(children, { className: "w1 fill-gray" })
    : null;

  return (
    <div
      className={`${!href ? "dn" : ""} ${
        !first ? "b--moon-gray bl ml3 pl3" : ""
      }`}
    >
      <a {...{ href, id }} target="_blank" rel="nofollow noopen">
        {updatedChildren}
      </a>
    </div>
  );
}

export default TopBar;
